export const sanatiseUrl = (str = "") => {
    return String(str)
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, '')     // remove non-alphanumeric except spaces
        .replace(/\s+/g, '-')            // replace spaces with hyphens
        .replace(/-+/g, '-');            // collapse multiple dashes
};

export const desanitiseUrl = (slug = "") => {
    return String(slug)
        .replace(/-/g, ' ')                     // replace hyphens with spaces
        .replace(/\b\w/g, char => char.toUpperCase()); // title case
};
